import getClient from './http-common'
import { getIsAuthorized } from './AccountProvider'
import { useQuery } from 'react-query'
import mergeWith from 'lodash/mergeWith'
import isNil from 'lodash/isNil'

// Requests

const getAccountDetails = () => getClient().get('/v1/accounts/me')

const getPerson = () => getClient().get('/v1/people/me')

const getState = ({ queryKey }) => {
  const [_, stateId] = queryKey
  return getClient().get(`/v1/states/${stateId}`)
}

const getStates = ({ queryKey }) => {
  const [_, countryId] = queryKey
  return getClient().get(`/v1/states?countryId=${countryId}&limit=1000`)
}

/***************************************************************************/

// Queries

// Account information: id, emailId, employee info, personId
const accountPlaceholder = {
  id: '',
  lastLoginTime: '',
}

export const useAccountQuery = () => {
  const query = useQuery('accounts', getAccountDetails, {
    enabled: getIsAuthorized(),
    retry: 0,
  })
  return mergeQueryData(accountPlaceholder, query)
}

// Person information: firstName, lastName, accountId
const personPlaceholder = {
  firstName: '',
  lastName: '',
}

export const usePersonQuery = () => {
  const query = useQuery('person', getPerson, {
    enabled: getIsAuthorized(),
    retry: 0,
  })
  return mergeQueryData(personPlaceholder, query)
}

export const useStateQuery = (stateId, options) => {
  const query = useQuery(['state', stateId], getState, {
    staleTime: Infinity,
    ...options,
  })
  return { ...query, data: query.data?.data }
}

export const useStatesQuery = (countryId, options) => {
  const query = useQuery(['states', countryId], getStates, {
    staleTime: Infinity,
    ...options,
  })
  return { ...query, data: query.data?.data }
}

/**
 * * Merges query data when it arrives into placeholder data.
 * @param {Array<any> | object} placeholderData
 * @param {object} query
 * @returns {object}
 */
const mergeQueryData = (placeholderData, query) => {
  const data = mergeWith(placeholderData, query?.data?.data, (obj, src) =>
    isNil(src) ? obj : src
  )
  return { ...query, data }
}
